import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import * as Comp from "../../common/CommonComponents";
import * as common from "../../common/common";
import http from "../../common/http-common";
import CssClass from "../../Styles/common.module.css";
import TicketListTable from "../../components/Ticket/TicketList/TicketListTable";
import { GetPagePermissionFn } from "../../common/authority";
import "react-datepicker/dist/react-datepicker.css";
import search from "../../assets/search-icon.png";
import exportIcon from "../../assets/export-icon.png";

const PAGE_NAME = "TicketList.js_";
const MODULE_ID = "WEB_TKT_001";

const TicketList = (props) => {
  document.title =  common.c_TITLE + " - Ticket List" ;
  const navigate = useNavigate();
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  const [allData, setAllData] = useState([]);
  const [inputError, setInputError] = useState([]);
  const [searchData, setSearchData] = useState({
    SEARCH_TICKET_NO: "",
    TICKET_STATUS: [],
    ORGANIZATION: [],
    SYSTEM: [],
    CATEGORY: [],
    PRIORITY: [],
    AGENT: []
  });
  const [selectedOrg, setSelectedOrg] = useState([]);

  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");

  const [disabledSysField, setDisabledSysField] = useState(false);
  const [disabledOrgField, setDisabledOrgField] = useState(false);

  const defaultStartDate = new Date();
  defaultStartDate.setHours(0,0,0)

  const defaultEndDate = new Date();
  defaultEndDate.setHours(23,59,59)

  // const [dateRange, setDateRange] = useState([defaultStartDate, defaultEndDate]); //default starting date
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  // const [ticketNo, setTicketNo] = useState("");

  const [dataToBeSelect, setDataToBeSelect] = useState({
    TicketStatus: [],
    Organization: [],
    System: [],
    Category: [],
    Priority: [],
    Agent: []
  });

  const [orgCategory, setOrgCategory] = useState("");

  const customSort = (statuses) => {
    const order = ["OPEN", "ACKNOWLEDGE", "RESOLVED", "VERIFIED"];
    
    return statuses.sort((a, b) => {
      return (order.indexOf(a.label) === -1 ? order.length : order.indexOf(a.label)) -
             (order.indexOf(b.label) === -1 ? order.length : order.indexOf(b.label));
    });
  };
  
  // const [TicketStatus, setTicketStatus] = useState([]);
  // const [orgData, setOrgData] = useState([]);
  // const [systemData, setSystemData] = useState([]);
  // const [categoryData, setCategoryData] = useState([]);
  // const [priorityData, setPriorityData] = useState([]);

  // const [selectedTicketStatus, setSelectedTicketStatus] = useState([]);
  // const [selectedOrg, setSelectedOrg] = useState([]);
  // const [selectedSystem, setSelectedSystem] = useState([]);
  // const [selectedCategory, setSelectedCategory] = useState([]);
  // const [selectedPriority, setSelectedPriority] = useState([]);

  const [actionAuthority, setActionAuthority] = useState({
    READ: "N",
    WRITE: "N",
  });

  useEffect(() => {
    let promise = GetPagePermissionFn(userId, MODULE_ID);
    promise.then(
      (result) => {
        setActionAuthority(result);
        if (result.READ === "N") {
          navigate("/Home");
        }
      },
      (error) => {
        setActionAuthority({
          READ: "N",
          WRITE: "N",
        });
        common.c_LogWebError(PAGE_NAME, "GetPagePermissionFn", error);
        toast.error(error);
        navigate("/Home");
      }
    );
  }, [userId, navigate]);
  
    useEffect(() => {
      let functionName = "";
  
      try {
        functionName = "Get Orginazation Category";
        onLoadingHandler(true, "Getting Orginazation Category, please wait...");
  
        var listItems = [];
        http
          .get(
            `api/ticket/GetOrgCategory?_user=${userId}`,
            { timeout: 100000 }
          )
          .then((response) => {
            setOrgCategory(response.data[0].ORG_CATEGORY_NAME);
          })
          .catch((err) => {
            toast.error("Error on Getting Orginazation Category.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            onLoadingHandler(false, "Loading...");
          });
      } catch (err) {
        toast.error("Error on Getting Orginazation Category.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }, [userId]);

  function searchAllTicket() {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        functionName = "Get All Tickets";

        // Check if no filters are selected
        if (
          startDate === null &&
          searchData.SEARCH_TICKET_NO === '' && 
          searchData.TICKET_STATUS.length === 0 &&
          searchData.ORGANIZATION.length === 0 &&
          searchData.SYSTEM.length === 0 &&
          searchData.CATEGORY.length === 0 &&
          searchData.PRIORITY.length === 0 &&
          searchData.AGENT.length === 0
      ) {
          onLoadingHandler(true, "Getting Tickets, please wait...");

          setAllData([]); // Clear previous data

          const ticketStatusValue =
          searchData.TICKET_STATUS !== undefined &&
          Object.keys(searchData.TICKET_STATUS).length !== 0
            ? searchData.TICKET_STATUS.map((m) => m.value).join(",")
            : "";

          const orgValue = searchData.ORGANIZATION !== undefined &&
          Object.keys(searchData.ORGANIZATION).length !== 0
            ? searchData.ORGANIZATION.map((m) => m.value).join(",")
            : "";

          const systemValue = searchData.SYSTEM !== undefined &&
          Object.keys(searchData.SYSTEM).length !== 0
            ? searchData.SYSTEM.map((m) => m.value).join(",")
            : "";

          const agentValue = searchData.AGENT !== undefined &&
          Object.keys(searchData.AGENT).length !== 0
            ? searchData.AGENT.map((m) => m.value).join(",")
            : "";

          const ticketNoSelected =
            searchData.SEARCH_TICKET_NO === undefined
              ? ""
              : searchData.SEARCH_TICKET_NO.trim();
    
          var newStartDate = "";
          var newEndDate = "";
    
          if (startDate === null && endDate === null) {
            // setDateRange([defaultStartDate, defaultEndDate])
            setDateRange([null, null])
            // newStartDate = common.c_Dis_DateTime(defaultStartDate).val;
            // newEndDate = common.c_Dis_DateTime(defaultEndDate).val;
          } else if (startDate !== null && endDate === null) {
            newStartDate = common.c_Dis_DateTime(startDate).val;
            newEndDate = "";
          } else {
            newStartDate = common.c_Dis_DateTime(startDate).val;
            newEndDate = common.c_Dis_DateTime(endDate).val;
          }

          // Fetch all tickets without filters
          http.get("api/ticket/GetAllTickets?_startDate=" +
                newStartDate +
                "&_endDate=" +
                newEndDate +
                "&_status=" +
                ticketStatusValue +
                "&_org=" +
                orgValue +
                "&_system=" +
                systemValue +
                "&_agent=" +
                agentValue +
                "&_ticketNo=" +
                ticketNoSelected +
                "&_user=" +
                userId, { timeout: 10000000 })
              .then((response) => {
                  const listItems = response.data.map((data, counter) => ({
                      key: counter,
                      TICKET_MST_ID: data.TICKET_MST_ID,
                      TICKET_NUM: data.TICKET_NUM,
                      ORG_ID: data.ORG_ID,
                      ORG_NAME: data.ORG_NAME,
                      SYSTEM_MST_ID: data.SYSTEM_MST_ID,
                      SYSTEM_MST_NAME: data.SYSTEM_MST_NAME,
                      SUBJECT: data.SUBJECT,
                      TICKET_DETAILS: data.TICKET_DETAILS,
                      CREATE_BY: data.CREATE_BY,
                      CREATE_NAME: data.CREATE_NAME,
                      CREATE_DATETIME: data.CREATE_DATETIME,
                      TICKET_CATEGORY_ID: data.TICKET_CATEGORY_ID,
                      TICKET_CATEGORY_NAME: data.TICKET_CATEGORY_NAME,
                      TICKET_PRIORITY_TYPE_ID: data.TICKET_PRIORITY_TYPE_ID,
                      TICKET_PRIORITY_TYPE_NAME: data.TICKET_PRIORITY_TYPE_NAME,
                      TICKET_STATUS_TYPE_ID: data.TICKET_STATUS_TYPE_ID,
                      TICKET_STATUS_TYPE_NAME: data.TICKET_STATUS_TYPE_NAME,
                      ACKNOWLEDGED_BY: data.ACKNOWLEDGED_BY,
                      ACKNOWLEDGED_NAME: data.ACKNOWLEDGED_NAME,
                      LEAD_TIME: data.LEAD_TIME,        //LEADTIME
                      TARGET_MANDAYS: data.TARGET_MANDAYS,
                      TOTAL_COMPLETE_TIME: data.TOTAL_COMPLETE_TIME,
                      ATTACHMENT_ID: data.ATTACHMENT_ID,
                      INTERNAL_NOTE: data.INTERNAL_NOTE,
                      STATUS: data.ACTIVE_FLAG === "Y" ? "Active" : "Inactive",
                      UPDATE_ID: data.UPDATE_ID,
                      UPDATE_NAME: data.UPDATE_NAME,
                      UPDATE_DATETIME: data.UPDATE_DATETIME,
                      READ_FLAG: data.READ_FLAG,
                      READ_BY: data.READ_BY,
                      LATEST_DEPLOYMENT_ATTACHMENT_ID: data.LATEST_DEPLOYMENT_ATTACHMENT_ID,
                  }));

                  setAllData(listItems);
              })
              .catch((err) => {
                  toast.error("Error on getting ticket list. Please try again.");
                  common.c_LogWebError(PAGE_NAME, functionName, err);
              })
              .finally(() => {
                  onLoadingHandler(false, "Loading...");   
              });
        //Filter Region
        }
        else {

          onLoadingHandler(true, "Getting Tickets, please wait...");

          setAllData([]);

          const listItems = [];
    
          // const ticketStatusValue = [];
          // selectedTicketStatus.map((data) => {
          //   ticketStatusValue.push(data.value);
          // });
          // searchData.TICKET_STATUS.map((data) => {
          //   ticketStatusValue.push(data.value);
          // });
          // const orgValue = [];
          // selectedOrg.map((data) => {
          //   orgValue.push(data.value);
          // });
    
          // const systemValue = [];
          // selectedSystem.map((data) => {
          //   systemValue.push(data.value);
          // });
    
          // const categoryValue = [];
          // selectedCategory.map((data) => {
          //   categoryValue.push(data.value);
          // });
    
          // const priorityValue = [];
          // selectedPriority.map((data) => {
          //   priorityValue.push(data.value);
          // });

          const ticketStatusValue =
          searchData.TICKET_STATUS !== undefined &&
          Object.keys(searchData.TICKET_STATUS).length !== 0
            ? searchData.TICKET_STATUS.map((m) => m.value).join(",")
            : "";

          const orgValue = searchData.ORGANIZATION !== undefined &&
          Object.keys(searchData.ORGANIZATION).length !== 0
            ? searchData.ORGANIZATION.map((m) => m.value).join(",")
            : "";

          const systemValue = searchData.SYSTEM !== undefined &&
          Object.keys(searchData.SYSTEM).length !== 0
            ? searchData.SYSTEM.map((m) => m.value).join(",")
            : "";

          const agentValue = searchData.AGENT !== undefined &&
          Object.keys(searchData.AGENT).length !== 0
            ? searchData.AGENT.map((m) => m.value).join(",")
            : "";
    
          // const categoryValue = searchData.CATEGORY !== undefined &&
          // Object.keys(searchData.CATEGORY).length !== 0
          //   ? searchData.CATEGORY.map((m) => m.value).join(",")
          //   : "";

          // const priorityValue = searchData.PRIORITY !== undefined &&
          // Object.keys(searchData.PRIORITY).length !== 0
          //   ? searchData.PRIORITY.map((m) => m.value).join(",")
          //   : "";  
    
          const ticketNoSelected =
            searchData.SEARCH_TICKET_NO === undefined
              ? ""
              : searchData.SEARCH_TICKET_NO.trim();
    
          var newStartDate = "";
          var newEndDate = "";
    
          if (startDate === null && endDate === null) {
            // setDateRange([defaultStartDate, defaultEndDate])
            setDateRange([null, null])
            // newStartDate = common.c_Dis_DateTime(defaultStartDate).val;
            // newEndDate = common.c_Dis_DateTime(defaultEndDate).val;
          } else if (startDate !== null && endDate === null) {
            newStartDate = common.c_Dis_DateTime(startDate).val;
            newEndDate = "";
          } else {
            newStartDate = common.c_Dis_DateTime(startDate).val;
            newEndDate = common.c_Dis_DateTime(endDate).val;
          }
    
          http
            .get(
              "api/ticket/GetAllTickets?_startDate=" +
                newStartDate +
                "&_endDate=" +
                newEndDate +
                "&_status=" +
                ticketStatusValue +
                "&_org=" +
                orgValue +
                "&_system=" +
                systemValue +
                "&_agent=" +
                agentValue +
                // "&_category=" +
                // categoryValue +
                // "&_priority=" +
                // priorityValue +
                "&_ticketNo=" +
                ticketNoSelected +
                "&_user=" +
                userId,
              { timeout: 10000000 }
            )
            .then((response) => {
              if (response.data.length > 0) {
                response.data.forEach((data, counter) => {
                  listItems.push({
                    key: counter,
                    TICKET_MST_ID: data.TICKET_MST_ID,
                    TICKET_NUM: data.TICKET_NUM,
                    ORG_ID: data.ORG_ID,
                    ORG_NAME: data.ORG_NAME,
                    SYSTEM_MST_ID: data.SYSTEM_MST_ID,
                    SYSTEM_MST_NAME: data.SYSTEM_MST_NAME,
                    SUBJECT: data.SUBJECT,
                    TICKET_DETAILS: data.TICKET_DETAILS,
                    CREATE_BY: data.CREATE_BY,
                    CREATE_NAME: data.CREATE_NAME,
                    CREATE_DATETIME: data.CREATE_DATETIME,
                    TICKET_CATEGORY_ID: data.TICKET_CATEGORY_ID,
                    TICKET_CATEGORY_NAME: data.TICKET_CATEGORY_NAME,
                    TICKET_PRIORITY_TYPE_ID: data.TICKET_PRIORITY_TYPE_ID,
                    TICKET_PRIORITY_TYPE_NAME: data.TICKET_PRIORITY_TYPE_NAME,
                    TICKET_STATUS_TYPE_ID: data.TICKET_STATUS_TYPE_ID,
                    TICKET_STATUS_TYPE_NAME: data.TICKET_STATUS_TYPE_NAME,
                    ACKNOWLEDGED_BY: data.ACKNOWLEDGED_BY,
                    ACKNOWLEDGED_NAME: data.ACKNOWLEDGED_NAME,
                    LEAD_TIME: data.LEAD_TIME,        //LEADTIME
                    TARGET_MANDAYS: data.TARGET_MANDAYS,
                    TOTAL_COMPLETE_TIME: data.TOTAL_COMPLETE_TIME,
                    ATTACHMENT_ID: data.ATTACHMENT_ID,
                    INTERNAL_NOTE: data.INTERNAL_NOTE,
                    STATUS: data.ACTIVE_FLAG === "Y" ? "Active" : "Inactive",
                    UPDATE_ID: data.UPDATE_ID,
                    UPDATE_NAME: data.UPDATE_NAME,
                    UPDATE_DATETIME: data.UPDATE_DATETIME,
                    READ_FLAG: data.READ_FLAG,
                    READ_BY: data.READ_BY,
                    LATEST_DEPLOYMENT_ATTACHMENT_ID: data.LATEST_DEPLOYMENT_ATTACHMENT_ID
                  });
                });
              }
              setAllData(listItems);
            })
            .catch((err) => {
              toast.error("Error on getting ticket list. Please try again.");
              common.c_LogWebError(PAGE_NAME, functionName, err);
            })
            .finally(() => {
              onLoadingHandler(false, "Loading...");   
            });    
        }        
      } catch (err) {
        toast.error("Error on getting ticket list. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  }

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        functionName = "useEffect Get All Ticket Status Type";
        onLoadingHandler(true, "Getting Ticket Status Type List, please wait...");
        http
          .get("api/ticket/GetTicketStatus?_user=" + userId)
          .then((response) => {
            const listItems = [];
            for (var i = 0; i < response.data.length; i++) {
              listItems.push({
                key: response.data[i].TICKET_STATUS_TYPE_ID,
                value: response.data[i].TICKET_STATUS_TYPE_ID,
                label: response.data[i].TICKET_STATUS_TYPE_NAME,
              });
            }
            // setTicketStatus(listItems);
            setDataToBeSelect((prevState) => ({
              ...prevState,
              TicketStatus: [...listItems],
            }));
          })
          .catch((err) => {
            toast.error("Error on getting ticket status. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
          });
      } catch (err) {
        toast.error("Error on getting ticket status. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
      }
    }  
  }, [reload, actionAuthority, userId]);

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        functionName = "useEffect Get All Company";
        onLoadingHandler(true, "Getting Company List, please wait..."); 
        http
          .get("api/ticket/GetOrgList?_user=" + userId)
          .then((response) => {
            if (response.data[0].ORG_CATEGORY_NAME !== "CUSTOMER") {
              const listItems = [];
              for (var i = 0; i < response.data.length; i++) {
                listItems.push({
                  key: response.data[i].ORG_ID,
                  value: response.data[i].ORG_ID,
                  label: response.data[i].ORG_NAME,
                });
              }
              // setOrgData(listItems);
              setDataToBeSelect((prevState) => ({
                ...prevState,
                Organization: [...listItems],
              }));
            } else {
              setDisabledOrgField(true);
              const listItems = [];
              for (var i = 0; i < response.data.length; i++) {
                listItems.push({
                  key: response.data[i].ORG_ID,
                  value: response.data[i].ORG_ID,
                  label: response.data[i].ORG_NAME,
                });
              }
              setDataToBeSelect((prevState) => ({
                ...prevState,
                Organization: [...listItems],
              }));
              setSelectedOrg([listItems[0]])
            }   
          })
          .catch((err) => {
            toast.error("Error on getting organization list. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
          })
          .finally(() => {
            onLoadingHandler(false, "Loading...");
          });
      } catch (err) {
        toast.error("Error on getting organization list. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
      }
    }
  }, [reload, actionAuthority, userId]);

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        functionName = "useEffect Get All System ";

        onLoadingHandler(true, "Getting System List, please wait...");

        // const orgSelected =
        //   selectedOrg !== undefined && Object.keys(selectedOrg).length !== 0
        //     ? selectedOrg.map((o) => o.key)
        //     : "";

        const orgSelected =
          searchData.ORGANIZATION !== undefined && Object.keys(searchData.ORGANIZATION).length !== 0
            ? searchData.ORGANIZATION.map((o) => o.key)
            : "" ;

        http
          .get(
            "api/ticket/GetSystemList?_user=" + userId + "&_org=" + orgSelected
          )
          .then((response) => {
            const listItems = [];
            for (var i = 0; i < response.data.length; i++) {
              listItems.push({
                key: response.data[i].SYSTEM_MST_ID,
                value: response.data[i].SYSTEM_MST_ID,
                label: response.data[i].SYSTEM_MST_NAME,
              });
            }
            // setSystemData(listItems);
            setDataToBeSelect((prevState) => ({
              ...prevState,
              System: [...listItems],
            })); 
            
            if (listItems.length === 1){
              setDisabledSysField(true);
              setSearchData({
                SYSTEM: listItems
              })
            }
          })
          .catch((err) => {
            toast.error("Error on getting system. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
          })
          .finally(() => {
            onLoadingHandler(false, "Loading...");
          })    
      } catch (err) {
        toast.error("Error on getting agent. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
      }
    }
  }, [/*reload,*/ searchData.ORGANIZATION, actionAuthority, userId]);

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        functionName = "useEffect Get All Agent List";
        onLoadingHandler(true, "Getting Agent List, please wait...");
        http
          .get("api/ticket/GetAgentList?_user=" + userId)
          .then((response) => {
            const listItems = [];
            for (var i = 0; i < response.data.length; i++) {
              listItems.push({
                key: response.data[i].ACKNOWLEDGED_BY,
                value: response.data[i].ACKNOWLEDGED_BY,
                label: response.data[i].ACKNOWLEDGED_NAME,
              });
            }
            // setTicketStatus(listItems);
            setDataToBeSelect((prevState) => ({
              ...prevState,
              Agent: [...listItems],
            }));
          })
          .catch((err) => {
            toast.error("Error on getting agent list. Please try again.1");
            common.c_LogWebError(props.page, functionName, err);
          });
      } catch (err) {
        toast.error("Error on getting agent list. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
      }
    }  
  }, [reload, actionAuthority, userId]);

  // useEffect(() => {
  //   if (actionAuthority.READ === "Y") {
  //     let functionName = "";

  //     try {
  //       functionName = "useEffect Get All Category";
  //       onLoadingHandler(true, "Getting Category List, please wait...");
  //       http
  //         .get("api/ticket/GetCategoryList?_user=" + userId)
  //         .then((response) => {
  //           const listItems = [];
  //           for (var i = 0; i < response.data.length; i++) {
  //             listItems.push({
  //               key: response.data[i].TICKET_CATEGORY_ID,
  //               value: response.data[i].TICKET_CATEGORY_ID,
  //               label: response.data[i].TICKET_CATEGORY_NAME,
  //             });
  //           }
  //           // setCategoryData(listItems);
  //           setDataToBeSelect((prevState) => ({
  //             ...prevState,
  //             Category: [...listItems],
  //           }));
  //         })
  //         .catch((err) => {
  //           toast.error("Error on getting category. Please try again.");
  //           common.c_LogWebError(props.page, functionName, err);
  //         });
  //     } catch (err) {
  //       toast.error("Error on getting category. Please try again.");
  //       common.c_LogWebError(props.page, functionName, err);
  //     }
  //   }
  // }, [reload, actionAuthority, userId]);

  // useEffect(() => {
  //   if (actionAuthority.READ === "Y") {
  //     let functionName = "";

  //     try {
  //       functionName = "useEffect Get All Priority Type";
  //       onLoadingHandler(true, "Getting Priority Type List, please wait...");
  //       http
  //         .get("api/ticket/GetPriorityList?_user=" + userId)
  //         .then((response) => {
  //           const listItems = [];
  //           for (var i = 0; i < response.data.length; i++) {
  //             listItems.push({
  //               key: response.data[i].TICKET_PRIORITY_TYPE_ID,
  //               value: response.data[i].TICKET_PRIORITY_TYPE_ID,
  //               label: response.data[i].TICKET_PRIORITY_TYPE_NAME,
  //             });
  //           }
  //           // setPriorityData(listItems);
  //           setDataToBeSelect((prevState) => ({
  //             ...prevState,
  //             Priority: [...listItems],
  //           }));
  //         })
  //         .catch((err) => {
  //           toast.error("Error on getting priority type. Please try again.");
  //           common.c_LogWebError(props.page, functionName, err);
  //         })
  //         .finally(() => {
  //           onLoadingHandler(false, "Loading...");
  //         });
  //     } catch (err) {
  //       toast.error("Error on getting priority type. Please try again.");
  //       common.c_LogWebError(props.page, functionName, err);
  //     }
  //   }
  // }, [reload, actionAuthority, userId]);

  //#region Event Handlers
  const selectionHandler = (val, field) => {
    let functionName = "";

    try {
      functionName = selectionHandler.name;
      setInputError((prevState) => ({
        ...prevState,
        [field]: "",
      }));
      setAllData((prevState) => ({
        ...prevState,
        [field]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  const inputUnrequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputUnrequiredHandler.name;
      const id = event.target.id;
      const val = event.target.value;

      setSearchData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  };

  const selectOrgHandler = (val) => {
    let functionName = "";

    try {
      functionName = selectOrgHandler.name;

      if (!disabledOrgField) {
        setSearchData((prevState) => ({
          ...prevState,
          ORGANIZATION: [...val],
        }));
      }   
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  const filterSelectionHandler = (val, field) => {
    let functionName = "";

    try {
      functionName = filterSelectionHandler.name;

      setSearchData((prevState) => ({
        ...prevState,
        [field]: [...val], 
      }));

    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  const onReloadHandler = () => {
    setReload(!reload);
  };

  const onLoadingHandler = (load, text) => {
    setLoading(load);
    setLoadingText(text);
  };
  //#endregion

  //#region Export Excel
  const onExcelHandler = () => {
    // const ticketStatusValue = [];
    // selectedTicketStatus.map((data) => {
    //   ticketStatusValue.push(data.value);
    // });

    // const orgValue = [];
    // selectedOrg.map((data) => {
    //   orgValue.push(data.value);
    // });

    // const systemValue = [];
    // selectedSystem.map((data) => {
    //   systemValue.push(data.value);
    // });

    // const categoryValue = [];
    // selectedCategory.map((data) => {
    //   categoryValue.push(data.value);
    // });

    // const priorityValue = [];
    // selectedPriority.map((data) => {
    //   priorityValue.push(data.value);
    // });

    const ticketStatusValue =
      searchData.TICKET_STATUS !== undefined &&
      Object.keys(searchData.TICKET_STATUS).length !== 0
        ? searchData.TICKET_STATUS.map((m) => m.value).join(",")
        : "";

    const orgValue = searchData.ORGANIZATION !== undefined &&
      Object.keys(searchData.ORGANIZATION).length !== 0
        ? searchData.ORGANIZATION.map((m) => m.value).join(",")
        : "";

    const systemValue = searchData.SYSTEM !== undefined &&
      Object.keys(searchData.SYSTEM).length !== 0
        ? searchData.SYSTEM.map((m) => m.value).join(",")
        : "";

    const agentValue = searchData.AGENT !== undefined &&
      Object.keys(searchData.AGENT).length !== 0
        ? searchData.AGENT.map((m) => m.value).join(",")
        : "";
  
    // const categoryValue = searchData.CATEGORY !== undefined &&
    //   Object.keys(searchData.CATEGORY).length !== 0
    //     ? searchData.CATEGORY.map((m) => m.value).join(",")
    //     : "";

    // const priorityValue = searchData.PRIORITY !== undefined &&
    //   Object.keys(searchData.PRIORITY).length !== 0
    //     ? searchData.PRIORITY.map((m) => m.value).join(",")
    //     : "";  

    const ticketNoSelected =
      searchData.SEARCH_TICKET_NO === undefined
        ? ""
        : searchData.SEARCH_TICKET_NO.trim();

    var newStartDate = "";
    var newEndDate = "";

    if (startDate === null && endDate === null) {
      newStartDate = "";
      newEndDate = "";
    } else if (startDate !== null && endDate === null) {
      newStartDate = common.c_Dis_DateTime(startDate).val;
      newEndDate = "";
    } else {
      newStartDate = common.c_Dis_DateTime(startDate).val;
      newEndDate = common.c_Dis_DateTime(endDate).val;
    }
    window.open(
      common.c_getApiUrl() +
        "api/ticket/ExportExcel?_startDate=" +
        newStartDate +
        "&_endDate=" +
        newEndDate +
        "&_status=" +
        ticketStatusValue +
        "&_agent=" +
        agentValue +
        "&_org=" +
        orgValue +
        "&_system=" +
        systemValue +
        // "&_category=" +
        // categoryValue +
        // "&_priority=" +
        // priorityValue +
        "&_ticketNo=" +
        ticketNoSelected +
        "&_user=" +
        userId
    );
  };
  //#endregion

  return (
    <>
      <Comp.Header>Ticket List</Comp.Header>

      <Comp.SearchPanel onSubmit={onReloadHandler}>
        <tr>
          <td style={{ verticalAlign: "middle", width: "10%" }}>
            Created Date
          </td>
          <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "15%" }}>
            <Comp.DateTimePicker
              selectsRange
              // className="datePickerControl"
              onChange={(dates) => setDateRange(dates)}
              startDate={startDate}
              endDate={endDate}
              // startDate={startDate === null ? new Date().setHours(0,0,0) : startDate}
              // endDate={endDate === null ? new Date().setHours(23,59,59) : endDate}
            />
          </td>
          <td style={{ verticalAlign: "middle", width: "10%" }}>Ticket #</td>
          <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "15%" }}>
            <Comp.Input
              id="SEARCH_TICKET_NO"
              type="text"
              className="form-control"
              isSearch={true}
              value={searchData.SEARCH_TICKET_NO}
              onChange={inputUnrequiredHandler}
              // placeholder="User ID"
            />
          </td>
          <td style={{ verticalAlign: "middle", width: "10%" }}>
            Ticket Status
          </td>
          <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "15%" }}>
            <Comp.Select
              id="TICKET_STATUS"
              // styles={{
              //   // Fixes the overlapping problem of the component
              //   menu: (provided) => ({ ...provided, zIndex: 9999 }),
              // }}
              // options={TicketStatus}
              options={customSort([...dataToBeSelect.TicketStatus])}
              closeMenuOnSelect={true}
              isClearable={true}
              hideSelectedOptions={false}
              // value={selectedTicketStatus}
              // onChange={setSelectedTicketStatus}
              value={searchData.TICKET_STATUS}
              onChange={(val) => filterSelectionHandler(val, "TICKET_STATUS")}
              // allowSelectAll
              isMulti
            />
          </td>
        </tr>
        <tr>
          <td style={{ verticalAlign: "middle", width: "10%" }}>Company</td>
          <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "15%" }}>
            <Comp.Select
              id="ORGANIZATION"
              // options={orgData}
              isDisabled={disabledOrgField}
              options={dataToBeSelect.Organization}
              closeMenuOnSelect={true}
              isClearable={true}
              hideSelectedOptions={false}
              // value={selectedOrg}
              // onChange={setSelectedOrg}
              value={searchData.ORGANIZATION = disabledOrgField ? selectedOrg : searchData.ORGANIZATION}
              // onChange={(val) => filterSelectionHandler(val, "ORGANIZATION")}
              // allowSelectAll
              onChange={selectOrgHandler}
              isMulti={!disabledOrgField}
            />
          </td>
          <td style={{ verticalAlign: "middle", width: "10%" }}>System</td>
          <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "15%" }}>
            <Comp.Select
              id="SYSTEM"
              // options={systemData}
              options={dataToBeSelect.System}
              closeMenuOnSelect={true}
              isClearable={true}
              hideSelectedOptions={false}
              // value={selectedSystem}
              // onChange={setSelectedSystem}
              value={searchData.SYSTEM}
              onChange={(val) => filterSelectionHandler(val, "SYSTEM")}
              isMulti={!disabledSysField}
              isDisabled={disabledSysField}
            />
          </td>
          <td style={{ verticalAlign: "middle", width: "10%" }}>Assigned To</td>
          <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "15%" }}>
            <Comp.Select
              id="AGENT"
              // options={agentData}
              options={dataToBeSelect.Agent}
              closeMenuOnSelect={true}
              isClearable={true}
              hideSelectedOptions={false}
              // value={selectedSystem}
              // onChange={setSelectedSystem}
              value={searchData.AGENT}
              onChange={(val) => filterSelectionHandler(val, "AGENT")}
              isMulti
            />
          </td>
          {/* <td style={{ verticalAlign: "middle", width: "10%" }}>Category</td>
          <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "15%" }}>
            <Comp.Select
              id="CATEGORY"
              // options={categoryData}
              options={dataToBeSelect.Category}
              closeMenuOnSelect={true}
              isClearable={true}
              hideSelectedOptions={false}
              // value={selectedCategory}
              // onChange={setSelectedCategory}
              value={searchData.CATEGORY}
              onChange={(val) => filterSelectionHandler(val, "CATEGORY")}
              isMulti
            />
          </td> */}
        </tr>
        {/* <tr>
          <td style={{ verticalAlign: "middle", width: "10%" }}>Priority</td>
          <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "15%" }}>
            <Comp.Select
              id="PRIORITY"
              // options={priorityData}
              options={dataToBeSelect.Priority}
              closeMenuOnSelect={true}
              isClearable={true}
              hideSelectedOptions={false}
              // value={selectedPriority}
              // onChange={setSelectedPriority}
              value={searchData.PRIORITY}
              onChange={(val) => filterSelectionHandler(val, "PRIORITY")}
              isMulti
            />
          </td>
        </tr> */}
      </Comp.SearchPanel>
      <div className={CssClass.btnWrapper}>
        <Comp.Button id="btnSearch" type="general" onClick={searchAllTicket}>
          SEARCH  <img src={search} alt="Search" style={{ width: "16px", height: "16px", marginBottom: "3px" }} />
        </Comp.Button>
        <Comp.Button id="btnExcel" type="excel" onClick={onExcelHandler}>
          EXPORT  <img src={exportIcon} alt="Export" style={{ width: "16px", height: "16px", marginBottom: "3px" }} />
        </Comp.Button>
      </div>
      <div className={`${CssClass.card} ${CssClass.tableCard}`}>
        {/* <h3 className={CssClass.tableTitle}>List of Ticket</h3> */}
        {/* <hr /> */}
        <div style={{ width: "100%" }}>
          <TicketListTable
            page={PAGE_NAME}
            module={MODULE_ID}
            data={allData}
            dataToBeSelect={dataToBeSelect}
            onReload={onReloadHandler}
            onLoading={onLoadingHandler}
            actionAuthority={actionAuthority}
            orgCategory={orgCategory}
          />
        </div>
      </div>
      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
    </>
  );
};

export default TicketList;
